import styled from "styled-components";

export const FooterWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.medium,
    width: "100%",
    background: `linear-gradient(to bottom, transparent, ${theme.colors[theme.colorMode].background_Primary})`,
    position: "fixed",
    bottom: 0,
    left: 0,
    paddingBottom: 20,
    zIndex: 4,

    "@supports (padding-bottom: var(--sab))": {
        paddingBottom: "calc(20px + var(--sab, 0px))",
    },
}));
